import { render, staticRenderFns } from "./home-2.vue?vue&type=template&id=e2b7899c&scoped=true&"
import script from "./home-2.vue?vue&type=script&lang=js&"
export * from "./home-2.vue?vue&type=script&lang=js&"
import style0 from "./home-2.vue?vue&type=style&index=0&id=e2b7899c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b7899c",
  null
  
)

export default component.exports